import { array, boolean, number, object, string } from "yup";
import { dateMax, stringMax } from "./utils";

export const edlItemSubItemValidationSchema = object({
  nom: stringMax(250).required(" "),
  note: number().integer().notRequired(" "),
  materiaux: array().of(string()),
  degradations: array().of(string()),
  photos: array().of(object()),
});

export const edlItemChildValidationSchema = object({
  nom: stringMax(250).required(" "),
  note: number().integer().notRequired(" "),
  materiaux: array().of(string()),
  degradations: array().of(string()),
  template_materiaux: number().notRequired(),
  quantite: number().notRequired(),
  commentaire: string().notRequired(),
  photos: array().of(object()),
  items: array().of(edlItemSubItemValidationSchema),
});

export const edlItemValidationSchema = object({
  items: array().of(edlItemChildValidationSchema),
  nom: stringMax(250).trim().required("Un nom de pièce doit être renseigné"),
  note: number().integer().notRequired(),
  is_shared: boolean(),
  commentaire: string().notRequired(),
  materiaux: array().of(string()),
  degradations: array().of(string()),
  quantite: number().notRequired(),
  photos: array().of(object()),
});

export const edlCleValidationSchema = object({
  nombre: number().required(" "),
  description: stringMax(250).notRequired(),
});

export const edlClesValidationSchema = object({
  cles: array().of(edlCleValidationSchema),
  photos_cles: array().of(object()),
});

export const EDL_CLE_INITIAL_VALUE = {
  nombre: "",
  description: "",
};

export const EDL_CLES_INITIAL_VALUE = {
  cles: [],
  photos_cles: [],
};

const profiles = object({
  present: string().required(" "),
  prenom: string().notRequired(),
  nom: string().notRequired(),
  represente_prenom: string().notRequired(),
  represente_nom: string().notRequired(),
  represente_qualite: string().notRequired(),
});

export const edlRealisationValidationSchema = object({
  profiles: array().of(profiles),
  profiles_bailleur: array().of(profiles),
  type_edl: string().required(
    "Le type d'état des lieux doit être renseigné (entrée / sortie)",
  ),

  description: string().notRequired(),
  date: dateMax().required("La date d'état des lieux doit être renseignée"),
  type_envoi: string().required(" "),
});
export const EDL_ITEM_INITIAL_VALUE = {
  nom: "",
  note: "",
  items: [],
  materiaux: [],
  degradations: [],
  photos: [],
  template: "",
  commentaire: "",
  is_shared: false,
  type: "edl",
  quantite: 0,
};
export const EDL_ITEM_CHILD_VALUE = {
  nom: "",
  note: "",
  items: [],
  materiaux: [],
  degradations: [],
  photos: [],
  is_shared: false,
  template_materiaux: "",
  quantite: 0,
  commentaire: "",
};

export const EDL_ITEM_SUBITEM_VALUE = {
  nom: "",
  note: "",
  materiaux: [],
  degradations: [],
  photos: [],
};

export const edlItemTemplateChildValidationSchema = object({
  nom: stringMax(250).required(" "),
  materiaux: array().of(string()),
  degradations: array().of(string()),
  template_materiaux: number(),
  quantite: number().notRequired(),
});
export const edlItemTemplateValidationSchema = object({
  items: array().of(edlItemTemplateChildValidationSchema),
  nom: stringMax(250).required(" "),
  is_shared: boolean(),
  materiaux: array().of(string()),
  degradations: array().of(string()),
});

export const EDL_ITEM_TEMPLATE_INITIAL_VALUE = {
  nom: "",
  items: [],
  materiaux: [],
  degradations: [],
  template: "",
  is_shared: false,
  type: "edl",
};
export const EDL_ITEM_TEMPLATE_CHILD_VALUE = {
  nom: "",
  items: [],
  materiaux: [],
  degradations: [],
  template_materiaux: "",
  is_shared: false,
};
export const edlItemMateriauxTemplateValidationSchema = object({
  nom: stringMax(250).required(" "),
  degradations: array().of(string()),
  materiaux: array().of(string()),
});
export const EDL_ITEM_MATERIAUX_TEMPLATE_INITIAL_VALUE = {
  nom: "",
  degradations: [],
  materiaux: [],
};

export const ETAT_OPTIONS = [
  { value: "1", label: "Neuf" },
  { value: "2", label: "Bon état" },
  { value: "3", label: "État d'usage" },
  { value: "4", label: "Mauvais état" },
];
